export class ServiceChargesModel {
    product: string;
    operation: string;
    partnerId: string;
    chargesInINR: number;
    partnerShareInINR: number;
    isEditable: boolean;
}


// WEBPACK FOOTER //
// ./src/app/_models/charges/ServiceChargesModel.ts